<template>
  <div class="edit-contingent">

    <b-modal id="mass-contingents-edit"
             :cancel-disabled="true"
             :ok-disabled="true"
             :title="$t('contingent_hotel.mass_edit.title')"
             :hide-footer="true"
    >
      <div>
        <form-base type="mass_contingents_edit"
                   :form-data=massEditData
                   :default-submit-button="false"
                   :callbacks="{ massEditContingents: onConfirmMassContingentsEdit }"
                   invoked-submit-button-name="massEditContingents"
                   @error="setErrorVisible"
                   :class="nameRoute"
        >

              <select-b-vue :options=roomTypes :label="$t('_hotel_gamme')" v-model="massEditData.hotelGamme">

              </select-b-vue>
              <div>
                {{ $t('_starting_date') }} *
              </div>
              <input class="form-control" required type="date" v-model="massEditData.startDate" v-on:change="startDateChange"
              />
              <div>
                {{ $t('_ending_date') }} *
              </div>
              <input class="form-control" required type="date" v-model="massEditData.endDate" v-on:change="endDateChange"
              />
              <text-input :label="$t('_qte')" :custom-input="false" name="quantity" v-model="massEditData.quantity"/>

            <div v-if="submitted" class="col-12">
              <b-alert v-if="success" variant="success" show>
                <span>{{ $t('contingent_hotel.mass_edit.success') }}</span>
              </b-alert>

              <b-alert v-if="errors.length" variant="danger" class="col-md-12"
                       dismissible show
              >
                <ul>
                  <li v-for="error in errors" :key="error.id" class="error">
                    <span class="label">
                      {{ $t(labels[error.field]) | capitalise }} :
                    </span>

                    {{ error.msg }}
                  </li>
                </ul>
              </b-alert>
            </div>

            <b-row class="justify-content-center">
              <submit-button v-if="!submitted || !success" class="btn"
                             text="_validate" name="massEditContingents"
              />
            </b-row>
        </form-base>
      </div>

    </b-modal>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import formBase from '@/components/frontoffice/form/base'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import customInputController from '@/components/frontoffice/form/customInput/controller'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import fa from '@/components/global/icon/fontAwesome'
import textInput from '@/components/frontoffice/form/baseInput/text'
import radioInput from '@/components/frontoffice/form/baseInput/radio'
import SelectBVue from "@/components/frontoffice/form/baseInput/selectBVue.vue";
import dateInput from '@/components/frontoffice/form/baseInput/date'

export default {
  components: {
    SelectBVue,
    formBase,
    bModal,
    customInputController,
    submitButton,
    fa,
    textInput,
    radioInput,
    dateInput
  },

  props: {
    hotelId: String,
    companyInputFields: Array,
    roomType: null,
    massEditData: {
      type: Object,
      default: () => {
        return {
          hotelGamme: '',
          startDate: '',
          endDate: '',
          quantity: ''
        }
      }
    },
    title: {
      type: String,
      default: '_edit'
    }
  },

  data () {
    return {
      context: this.$route.matched[0].name === 'admin',
      nameRoute: this.$route.matched[0].name,
      showModal: false,
      commonApi: new CommonApi(),
      submitted: false,
      success: false,
      errors: [],
      labels: {
        hotelGamme: '_hotel_gamme',
        startDate: '_starting_date',
        endDate: '_ending_date',
        quantity: '_qte',
        enabled: '_enabled'
      },
      roomTypes: []
    }
  },

  async created () {
    await this.getRoomTypes()
    this.showModal = true
  },

  methods: {
    clone: x => JSON.parse(JSON.stringify(x)),

    setErrorVisible (errors) {
      this.submitted = true
      this.success = false
      this.errors = errors
    },

    onConfirmMassContingentsEdit (data) {
      this.success = true
      this.submitted = true

      setTimeout(() => {
        this.showModal = false
        this.submitted = false
        this.$emit('input', data)
      }, 3000)
    },

    onInputCustomFields (newVal) {

    },

    startDateChange (e) {
      let startDate = new Date(e.target.value)
      let endDate = new Date()
      if (this.massEditData.endDate) {
        endDate = new Date(this.massEditData.endDate)
      }

      // On ne met à jour la date de fin que si elle n'est pas déjà définie ou si elle se retrouve inférieure
      if (!this.massEditData.endDate || endDate <= startDate) {
        endDate.setDate(startDate.getDate() + 1)
        this.massEditData.endDate = endDate.toISOString().split('T')[0]
      }
    },

    endDateChange (e) {
      let endDate = new Date(e.target.value)
      let startDate = new Date()
      if (this.massEditData.startDate) {
        startDate = new Date(this.massEditData.startDate)
      }

      // On ne met à jour la date de fin que si elle n'est pas déjà définie ou si elle se retrouve inférieure
      if (!this.massEditData.startDate || startDate >= endDate) {
        startDate.setDate(endDate.getDate() - 1)
        this.massEditData.startDate = startDate.toISOString().split('T')[0]
      }
    },

    /**
     * Get room options
     * @returns {Promise<Array<>>}
     */
    async getRoomTypes () {
      let hotelGammes = await this.commonApi.getHotelGammes(this.hotelId)
      let hotelGammesData = hotelGammes.data.data
      this.roomTypes = hotelGammesData.map(hotelGamme => {
        return {
          value: hotelGamme.id.toString(),
          text: hotelGamme.description
        }
      })
    }
  }
}
</script>
<style scoped>
.admin form .custom-input:not(.dates){
  border-bottom: none;
  margin-right: 1rem;
}

.admin form .custom-input {
  border-bottom: none;
  margin-top: 0;
  height: 90px;
}

.admin form .refs-input{
  padding-left: 0;
  padding-right: 0;
}

.admin .input-inner{
  border-bottom: none;
}
</style>
